import { ref, computed } from "vue";
import { defineStore } from "pinia";
import {
    useAppStore,
    useAuthStore,
    useMessageStore,
    useRequestStore } from "#imports";

export const usePageStore = defineStore('pageStore', () => {
    const { txt } = storeToRefs(useAppStore());
    const authStore = useAuthStore();
    const { isDemo, isManager, isMember, redeemedCodes } = storeToRefs(authStore);
    const messageStore = useMessageStore();
    const { pendingMsgCnt } = storeToRefs(messageStore);
    const requestStore = useRequestStore();
    const { pendingReqCnt } = storeToRefs(requestStore);

    const _isPending = ref<boolean>(false);
    const changesExist = ref<boolean>(false);
    const isForceNav = ref<boolean>(false);
    const isWarningShown = ref<boolean>(false);
    const tempNavTo = ref<Object | null>(null);
    const prevRoute = ref<string>('');
    const pages = computed(() => [
        {
            title: txt.value.account,
            id: 1,
            icon: '$mdi-account-circle-outline',
            to: isDemo.value ? '/demo/account' : '/account',
            isShow: true
        },
        {
            title: txt.value.schedules,
            id: 2,
            icon: '$mdi-calendar-blank-multiple',
            to: isDemo.value ? '/demo/schedules' : '/schedules',
            isShow: isMember.value && redeemedCodes.value.length > 0
        },
        {
            title: txt.value.setup,
            id: 3,
            icon: '$mdi-card-account-details-outline',
            to: isDemo.value ? '/demo/setup' : '/setup',
            isShow: isManager.value && redeemedCodes.value.length > 0
        },
        {
            title: pendingReqCnt.value > 0 ? `${txt.value.requests} (${pendingReqCnt.value})` : txt.value.requests,
            id: 4,
            icon: '$mdi-email-multiple-outline',
            to: isDemo.value ? '/demo/request' : '/request',
            isShow: isMember.value && redeemedCodes.value.length > 0
        },
        {
            title: pendingMsgCnt.value > 0 ? `Messages (${pendingMsgCnt.value})` : 'Messages',
            id: 5,
            icon: '$mdi-forum',
            to: isDemo.value ? '/demo/message' : '/message',
            isShow: isMember.value
        },
        {
            title: txt.value.support,
            id: 6,
            icon: '$mdi-help-circle-outline',
            to: isDemo.value ? '/demo/support' : '/support',
            isShow: isMember.value
        }
    ]);

    const isPending = computed(() => { return _isPending.value });

    function $reset(): void {
        changesExist.value = false;
        isForceNav.value = false;
        isWarningShown.value = false;
        tempNavTo.value = null;
        _isPending.value = false;
    }

    return {
        pages, changesExist, isForceNav, isWarningShown, tempNavTo, isPending, prevRoute,
        $reset
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePageStore, import.meta.hot))
}